import React, { useEffect, useRef, useState } from 'react';
import { FormControl, Box, Heading, useStyleConfig, Button, Image, Text, Link } from '@chakra-ui/react';
import ElementErrorMessage from '../../../formElements/components/ElementErrorMessage';
import { Field } from 'formik';
import VideoRecorder from './video_recorder';
import { InterviewUtils } from '../utils';
import { onLink } from '../../../handlers';
import { FaDownload } from 'react-icons/fa';
import { RiPlayFill, RiRefreshLine, RiVideoOnFill } from 'react-icons/ri';
import { editMIResults, editResults } from './utils';

// A React-integrated wrapper for the video recorder/upload UI. It instantiates
// the VideoRecorder class against the component's root DOM node and cleans up on unmount.
const RSVideoUpload = ({ props }) => {
  const variant = 'wrapper';
  const elementStyles = useStyleConfig('Element', { variant });
  const buttonStyles = useStyleConfig('Button', { variant });
  const rootRef = useRef(null);
  const recorderRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isSideVideoPlaying, setIsSideVideoPlaying] = useState(false);
  const fieldName = 'test';
  const instructions = 'Record and submit your practice response for personalized feedback and guidance.';

  const iu = new InterviewUtils(props);
  const question = props.stateProps.interviewQuestion !== undefined ? props.stateProps.interviewQuestion : 'Please tell us why you want this job?';
  useEffect(() => {
    if (rootRef.current) {
      // Initialize the recorder scoped to this component's root
      recorderRef.current = new VideoRecorder({
        root: rootRef.current,
        question: question,
        onRecordingChange: (rec) => {
          setIsRecording(!!rec);
          if (rec) {
            // If recording starts, stop/disable side playback
            setIsSideVideoPlaying(false);
          }
        },
      });
      // Apply current disabled state based on side video playing
      if (recorderRef.current?.setRecordDisabled) {
        recorderRef.current.setRecordDisabled(isSideVideoPlaying);
      }
    }
    return () => {
      // Cleanup any event listeners / media tracks
      if (recorderRef.current && typeof recorderRef.current.destroy === 'function') {
        recorderRef.current.destroy();
      }
      recorderRef.current = null;
    };
  }, [question]);

  // When side video play state changes, toggle recorder availability
  useEffect(() => {
    if (recorderRef.current?.setRecordDisabled) {
      recorderRef.current.setRecordDisabled(isSideVideoPlaying);
    }
  }, [isSideVideoPlaying]);

  const styles = {};
  styles.interview = useStyleConfig('Interview', { variant });
  styles.button = useStyleConfig('Button', { variant });
  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        return (
          <FormControl sx={{ ...elementStyles }}>
            <Box id="answerQuestion" width="70%">
              <Heading className="qHeading">{question}</Heading>
              {instructions && <Box whiteSpace="pre-wrap">{instructions}</Box>}
              <Box className="rsTextAreaVideoWrapper" ref={rootRef} sx={{ width: '100%' }} borderWidth="1px"
                   borderRadius="md">

                <Box area="form" className="formWrapper" sx={{ width: '100% !important' }}>

                  {/* Two-column layout: left placeholder video, right recorder */}
                  <Box className="wp-video-recorder-container" display="flex" gap={4} alignItems="center"
                       justifyContent="center">
                    {/* Left: Placeholder video area */}


                    {/* Right: Recorder and Upload UI */}
                    <Box flex="2" width="90%" maxW="90%" p={3}>
                      <Box className="video-recorder" id="videoRecorder">

                        {/* Live camera preview */}
                        <Box mt={3}>
                          <video id="livePreview"
                                 style={{ width: '100%', backgroundColor: '#000', minHeight: '432px', borderRadius: 8 }}
                                 autoPlay muted playsInline />
                        </Box>
                        <Box id="recorder-nav" display="flex" justifyContent="center"
                        >
                          <Box className="recorder-controls" mt={3} display="flex" gap={3} justifyContent="flex-end"
                               alignItems="flex-end">
                            <Button id="recordBtn"
                                    sx={{ ...buttonStyles.primary, ...buttonStyles.careerSummaryContinue }}
                                    type="button"><RiVideoOnFill marginRight=".5rem" /> Record</Button>
                          </Box>
                          <Box className="video-preview" id="videoPreview" sx={{
                          'display': 'none',
                          'justifyContent': 'flex-end',
                          'float': 'right',
                          'marginTop': '1rem',
                        }}>
                          <input type="hidden" id="fileName" className="file-name-input"
                                 placeholder="Enter file name (without extension)" />
                            <Link id="replayLink" sx={{ ...buttonStyles.primary, ...buttonStyles.replayMockInterview }}
                                  target="_blank" rel="noopener noreferrer"><RiPlayFill
                              style={{ display: 'inline' }} /> Watch</Link>
                            <Button id="uploadBtn"
                                    sx={{ ...buttonStyles.primary, ...buttonStyles.careerSummaryContinue }}
                                    type="button">↑ Submit</Button>


                        </Box>



                        </Box>

                        {isSideVideoPlaying && (
                          <Text fontSize="sm" color="gray.600" mt={2}>
                            Recording is disabled while the coach video is playing.
                          </Text>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  <Box padding="0 2rem" id="showStatus"></Box>
                  <Box padding="2rem 2rem !important" id="statusMessage" className="video-recorder"></Box>
                </Box>

              </Box>
            </Box>
            {/* Results/Status Area */}
            <Box id="results" width="70%">
              <Heading marginBottom="1rem">Your Results</Heading>
              <Box area="form" sx={{
                padding: '.5rem',
                whiteSpace: 'break-spaces',
                border: '1px solid rgb(51,51,51)',
                borderRadius: '10px',
                paddingBottom: '2rem',
                overflowY: 'auto',
                maxHeight: '500px',
              }}>
                <Box className="video-recorder" id="results" padding=".5rem">
                  <div id="transcripts"></div>
                  <div id="sentiments"></div>

                </Box>
              </Box>
              <Button marginTop="1rem" borderRadius="5px" onClick={(e) => {
                editMIResults(props);
              }}>Start Over</Button>
            </Box>

            {/* Error message placeholder to mirror RSTextareaVideo structure */}
          </FormControl>
        );
      }}
    </Field>
  );
};

export default RSVideoUpload;
/*<video id="videoPlayback" controls width="100%"></video>*/
/*                        <Button id="rerecordBtn" sx={{...buttonStyles.update}} type="button"><RiRefreshLine marginRight='.5rem'/> Rerecord</Button>
                        */